import { render, staticRenderFns } from "./RecalculateManifestRoute.vue?vue&type=template&id=23fe5b80&scoped=true&"
import script from "./RecalculateManifestRoute.vue?vue&type=script&lang=js&"
export * from "./RecalculateManifestRoute.vue?vue&type=script&lang=js&"
import style0 from "./RecalculateManifestRoute.vue?vue&type=style&index=0&id=23fe5b80&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe5b80",
  null
  
)

export default component.exports